import { Injectable } from '@angular/core';
import { StarMoneyFacadeService } from '../core';
import AuthClient from '../lib/auth/client';



@Injectable({
  providedIn: 'root', // Provides the service at the root level
})
export class AuthService {
  public auth: AuthClient;

  constructor(private starMoneyFacadeService: StarMoneyFacadeService) {
    this.auth = new AuthClient(this.starMoneyFacadeService);
  }

  async signIn(session_id: string, is_bulk: boolean) {
    return this.auth.signInAnonymous(session_id, is_bulk);
  }

  public async getSession() {
    return this.auth.getSession();
  }
}
